import {
  REFERRAL_GET_REQUEST,
  REFERRAL_GET_SUCCESS,
  REFERRAL_GET_FAILURE,
  REFERRAL_GET_CLOSE_DATE_RANGE_REQUEST,
  REFERRAL_GET_CLOSE_DATE_RANGE_SUCCESS,
  REFERRAL_GET_CLOSE_DATE_RANGE_FAILURE,
  REFERRAL_CLOSE_REQUEST,
  REFERRAL_CLOSE_SUCCESS,
  REFERRAL_CLOSE_FAILURE,
  REFERRALS_SYNC_REQUEST,
  REFERRALS_SYNC_SUCCESS,
  REFERRALS_SYNC_FAILURE,
  REFERRALS_SYNC_RESET,
} from '../../../actions/constants/types';

const initialState = {
  isFetching: false,
  referral: undefined,
  isSynced: false,
  message: null,
  closeDateRange: {
    isFetchingDateRange: false,
    errorMessage: null,
    referralCloseDateRange: {
      canCloseReferral: null,
      minimumCloseDate: null,
      maximumCloseDate: null,
    },
  },
};

function referral(state = initialState, action) {
  switch (action.type) {
    case REFERRAL_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        referral: undefined,
      };
    case REFERRAL_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        referral: action.response.data.referral,
      };
    case REFERRAL_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        referral: undefined,
      };
    case REFERRAL_CLOSE_REQUEST: {
      return {
        ...state,
        closeDateRange: {
          ...state.closeDateRange,
          isFetching: true,
          errorMessage: null,
        },
      };
    }
    case REFERRAL_GET_CLOSE_DATE_RANGE_REQUEST: {
      return {
        ...state,
        closeDateRange: {
          ...state.closeDateRange,
          isFetching: true,
          errorMessage: null,
          referralCloseDateRange: initialState.closeDateRange.referralCloseDateRange,
        },
      };
    }
    case REFERRAL_CLOSE_FAILURE: {
      return {
        ...state,
        closeDateRange: {
          ...state.closeDateRange,
          isFetching: false,
          errorMessage: action.message.translationKey,
        },
      };
    }
    case REFERRAL_CLOSE_SUCCESS: {
      return {
        ...state,
        closeDateRange: {
          ...state.closeDateRange,
          isFetching: false,
        },
      };
    }
    case REFERRAL_GET_CLOSE_DATE_RANGE_SUCCESS: {
      return {
        ...state,
        closeDateRange: {
          ...state.closeDateRange,
          isFetching: false,
          referralCloseDateRange: action.response.data.referralCloseDateRange,
        },
      };
    }
    case REFERRAL_GET_CLOSE_DATE_RANGE_FAILURE: {
      return {
        ...state,
        closeDateRange: {
          ...state.closeDateRange,
          isFetching: false,
          referralCloseDateRange: initialState.closeDateRange.referralCloseDateRange,
        },
      };
    }
    case REFERRALS_SYNC_REQUEST: {
      return {
        ...state,
        isFetching: true,
        isSynced: false,
      };
    }
    case REFERRALS_SYNC_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        isSynced: true,
        message: action.response.data.message,
        isPatientActive: action.response.data.isPatientActive,
      };
    }
    case REFERRALS_SYNC_FAILURE: {
      return {
        ...state,
        isFetching: false,
        isSynced: false,
      };
    }
    case REFERRALS_SYNC_RESET: {
      return {
        ...state,
        isSynced: false,
      };
    }
    default:
      return state;
  }
}

export default referral;
